export default __webpack_public_path__ + "static/media/bw-planning-tutorial-pop-up-step-1.debe41b3.svg";